import { schema } from 'normalizr';

export const CategoryGroupSchema = new schema.Entity('categoryGroup');



// WEBPACK FOOTER //
// ./src/vas/business-objects/category-group/category-group.schema.ts